import DashboardSidebar from "@/dashboard/dashboard-sidebar/dashboard-sidebar.vue";
import { SidebarNavItem } from "@/dashboard/models/dashboard-enums";
import MyAccount from "@/dashboard/my-account/my-account.vue";
import MySettings from "@/dashboard/my-settings/my-settings.vue";
import WelcomePage from "@/dashboard/welcome-page/welcome-page.vue";
import { routerModel } from "@/router/router.model";
import { useI18n } from "@/shared/composables/use-i18n";
import { pageLoaderModel } from "@/shared/models/page-loader";
import { Options, setup, Vue } from "vue-class-component";

@Options({
    components: {
        "dashboard-sidebar": DashboardSidebar,
        "welcome-page": WelcomePage,
        "my-account": MyAccount,
        "my-Settings": MySettings,
    },
})
export class Dashboard extends Vue {
    i18n = setup(useI18n);
    pageLoader = pageLoaderModel;
    navItem = SidebarNavItem;
    activeNavItem = this.navItem.welcome;
    routerModel = routerModel;

    beforeMount() {
        this.pageLoader.toggle(true);
    }

    mounted() {
        this.pageLoader.toggle(false);
    }
}
